import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";

const base = resolveApiUrl("/api/destinations");

/**
 * מזהה יעד פנימי (public.internal_hotel_destinations.id) מתשובת GET /api/destinations/resolve.
 * סדר: internal_destination_id → destination_id רק אם מספרי חיובי (legacy).
 * @param {Record<string, unknown> | null | undefined} data
 * @returns {number | null}
 */
export function pickInternalDestinationFromResolveResponse(data) {
  if (!data || typeof data !== "object") return null;
  const iid = Number(data.internal_destination_id);
  if (Number.isFinite(iid) && iid > 0) return Math.trunc(iid);
  const legacy = Number(data.destination_id);
  if (Number.isFinite(legacy) && legacy > 0) return Math.trunc(legacy);
  return null;
}

/**
 * @param {{ lds_code?: string, name?: string }} params
 * @returns {Promise<{
 *   status: string,
 *   destination_id?: number | string,
 *   internal_destination_id?: number | null,
 *   canonical_destination_uuid?: string,
 *   name?: string,
 *   lds_code?: string | null
 * }>}
 * status: ok — יש קוד LDS תקף; partial — lds_code יכול להיות null.
 * מזהה עסקי מומלץ: internal_destination_id (מספר שלם).
 */
export async function resolveDestination(params = {}) {
  const lds = params.lds_code != null ? String(params.lds_code).trim() : "";
  const name = params.name != null ? String(params.name).trim() : "";
  const { data } = await axios.get(`${base}/resolve`, {
    params: {
      ...(lds ? { lds_code: lds } : {}),
      ...(name ? { name } : {}),
    },
    withCredentials: true,
  });
  return data;
}
